import * as React from 'react';

import {setBodyId} from '../../../dom';
import {ProductCategoriesWrapper} from '../../../ui/categories/product-categories-wrapper';
import {PageContainer, PageTitleBar} from '../../../ui/layout';

export function CategoriesPageStandalone() {
    setBodyId('list-product-categories');

    return (
        <PageContainer
            title='Categories'
            pageTitleBar={
                <PageTitleBar
                    title='Categories'
                    subheaderPrimaryText='Create product categories to group specific products.'
                />
            }
            whiteBackground={true}
        >
            <ProductCategoriesWrapper />
        </PageContainer>
    );
}
